import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import SDKMessageBus from '../utility/message-bus';
import deprecate from 'q2-tecton-common/lib/utility/deprecate';

export default function sendOverpanel(
    messageBus: SDKMessageBus,
    moduleId: string,
    capabilities: Set<string>
) {
    if (!capabilities.has('sendOverpanel') || moduleId.includes('tectonOverpanel')) {
        return;
    }

    return function(overpanelPath: string, params?: IDict<string>): Promise<void> {
        deprecate('sendOverpanel is deprecated in favor of showOverpanel.', {
            until: '1.0.0',
            package: 'q2-tecton-sdk'
        });

        const body = Maybe.maybe(params)
            .map<{ moduleId: string; overpanelPath: string; params?: IDict<string> }>(
                parameters => ({
                    moduleId,
                    params: parameters,
                    overpanelPath
                })
            )
            .altMap(() => Maybe.just({ overpanelPath, moduleId }))
            .map(JSON.stringify);
        return messageBus.sendRequest<void>('sendOverpanel', body).then(response => response.value);
    };
}
